<template>
  <PageTerms v-bind="{ terms }" />
</template>

<script setup>
const terms = {
  name: "Cookie Policy",
  lastUpdated: "10th February 2023",
  content: [
    {
      heading: "What are cookies?",
      clauses: [
        "Cookies are small text files that are placed on your computer by websites that you visit. ",
        "This Cookie Policy explains how we use cookies and the choices you have to control them. ",
        "Unless otherwise stated in this policy, our Privacy Policy applies to the data we collect.",
      ],
    },
    {
      heading: "Necessary cookies",
      clauses: [
        "Basic operational cookies are necessary for us to provide you with the services explicitly requested by you; and to enable you to move around the website/application and use their related features.",
        "Preferences cookies to remember your browser and languages preferences.",
        "Personalized cookies to allow us to personalize our services with content more relevant, stories and suggestions based on your behaviour on the website and application.",
        "Security cookies to increase the security of the service and to detect repeated failed login or similar mechanisms designed to protect you from abuse.",
        "These cookies have a retention period of 1 month.",
      ],
    },
    {
      heading: "Third party cookies",
      clauses: [
        {
          subheading:
            "Analytics and measurement cookies. Data retention period is subject to each 3rd party’s policy.",
          subclauses: [
            "Google analytics & Firebase will collect your IP address and information about your use (how often, which pages) of our website and application to allow us improving our services and contents. ",
            "Hubspot to help us to understand your use of our services and improve our services. Hubspot may collect your age, IP address, user ID, language and device preferences. ",
          ],
        },
        {
          subheading:
            "Analytics and advertising cookies. Data retention period is subject to each 3rd party’s policy.",
          subclauses: [
            "We may use a service like Doubleclick for the purpose of analysing the effectiveness of an ad campaign in order to avoid displaying twice the same advertisements to the same user. ",
            "We may use services like Facebook, Twitter, Snapchat, Bing, Pinterest, TikTok, Branch, InMobi and/or ironSource for the purpose of delivering advertisements and measure their performance to be able to display advertisements tailored to your activity and usage of the website and application. ",
          ],
        },
      ],
    },
    {
      heading: "Social networks cookies",
      clauses: [
        "Cookies that are set by the following social networks are intended to allow you to facilitate the sharing of content and to improve your experience.",
        "Facebook, Reddit ,Tumblr, Twitter, LINE, Instagram, Whatsapp.",
        "The social networks provided may vary by region.",
      ],
    },
  ],
};

const config = useRuntimeConfig();
const title = ref("Cookie Policy");
const canonical = ref(`${config.public.baseUrl}/en/terms/cookie`);
definePageMeta({ title: "Cookie Policy" });

useHead({
  title: title,
  link: [{ rel: "canonical", href: canonical }],
  meta: [
    {
      property: "og:title",
      content: `${title.value} - ${config.public.siteName}`,
    },
  ],
});
</script>
